import formTranslation from './form.translation';
import notificationsTranslation from './notifications.translation';
import layoutTranslation from './layout.translation';
import constantsTranslation from './constants.translation';

const enUSTranslation = {
  ...notificationsTranslation,
  ...formTranslation,
  ...layoutTranslation,
  ...constantsTranslation,
};

export default enUSTranslation;
